import * as tslib_1 from "tslib";
import setForwardingEmailAddress from '../actions/setForwardingEmailAddress';
import setKeepCopyState from '../actions/setKeepCopyState';
import store from '../store/store';
import getChoiceGroupSelection from '../utils/getChoiceGroupSelection';
import getForwardingEmailAddress from '../utils/getForwardingEmailAddress';
import getKeepCopy from '../utils/getKeepCopy';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { OptionsCheckbox } from 'owa-options-controls';
import isValidEmailAddress from 'owa-readwrite-recipient-well/lib/utils/isValidEmailAddress';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
var styles = require('./ForwardingForm.scss');
var ForwardingForm = /** @class */ (function (_super) {
    tslib_1.__extends(ForwardingForm, _super);
    function ForwardingForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onEmailAddressChanged = function (text) {
            setForwardingEmailAddress(text);
        };
        _this.onKeepCopyStateChanged = function (ev, checked) {
            setKeepCopyState(checked);
        };
        return _this;
    }
    ForwardingForm.prototype.render = function () {
        var isForwardingEnabled = getChoiceGroupSelection() === 'start';
        var forwardingEmailAddress = isForwardingEnabled ? getForwardingEmailAddress() : '';
        var keepCopy = isForwardingEnabled ? getKeepCopy() : false;
        /**
         * Show the error message if:
         *  - "Start forwarding" is checked
         *  - The user has entered text in the input
         *  - The text in the input is invalid
         */
        var showErrorMessage = isForwardingEnabled &&
            !isValidEmailAddress(forwardingEmailAddress) &&
            forwardingEmailAddress !== null;
        return (React.createElement("div", { className: styles.formContainer },
            React.createElement(Label, { className: styles.label }, strings.options_forwarding_input_label),
            React.createElement(TextField, { className: styles.emailInput, value: forwardingEmailAddress, onChanged: this.onEmailAddressChanged, disabled: !isForwardingEnabled, placeholder: strings.options_forwarding_input_placeholder, errorMessage: showErrorMessage ? strings.options_forwarding_input_error : null }),
            React.createElement(OptionsCheckbox, { label: strings.options_forwarding_keepCopy_label, checked: keepCopy, onChange: this.onKeepCopyStateChanged, disabled: !isForwardingEnabled })));
    };
    ForwardingForm = tslib_1.__decorate([
        reactive({
            optionState: function () { return store; },
        })
    ], ForwardingForm);
    return ForwardingForm;
}(React.Component));
export default ForwardingForm;
//# sourceMappingURL=ForwardingForm.js.map